import React from "react";

import t from "../../../utils/translate";
import IntegerInput from "../IntegerInput";

import styles from "../styles.module.scss";

import {
  MEDICAL,
  BLOOD_PRESSURE_SYS,
  BLOOD_PRESSURE_DIA,
  BLOOD_PRESSURE_UNKNOWN
} from "../constants";

const BloodPressure = ({ onChange, profile, newQuiz }) => {
  const isDisabled = profile[MEDICAL][BLOOD_PRESSURE_UNKNOWN] || false;
  return (
    <>
      <IntegerInput
        disabled={isDisabled}
        name={BLOOD_PRESSURE_SYS}
        label={t("BLOOD_PRESSURE_SYS")}
        value={profile[MEDICAL][BLOOD_PRESSURE_SYS]}
        onChange={value => onChange(BLOOD_PRESSURE_SYS, value, MEDICAL)}
        styles={styles}
        min={10}
        max={300}
        errorMessage={t("BLOOD_PRESSURE_INVALID")}
        placeholder={newQuiz.isSequence ? t("JS_BLOOD_PRESSURE_SYS") : ""}
      />
      <IntegerInput
        disabled={isDisabled}
        name={BLOOD_PRESSURE_DIA}
        label={t("BLOOD_PRESSURE_DIA")}
        value={profile[MEDICAL][BLOOD_PRESSURE_DIA]}
        onChange={value => onChange(BLOOD_PRESSURE_DIA, value, MEDICAL)}
        styles={styles}
        min={10}
        max={300}
        errorMessage={t("BLOOD_PRESSURE_INVALID")}
        withAutofocus={false}
        placeholder={newQuiz.isSequence ? t("JS_BLOOD_PRESSURE_DIA") : ""}
      />
    </>
  );
};

export default BloodPressure;
